import { render } from "./FontStyleItem.vue?vue&type=template&id=2ada2a3c"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"

import "./FontStyleItem.vue?vue&type=style&index=0&id=2ada2a3c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__